export default "__VITE_ASSET__BzbxkNNx__"